import { render, staticRenderFns } from "./ReportAgentPage.vue?vue&type=template&id=1bc46a86"
import script from "./ReportAgentPage.vue?vue&type=script&lang=js"
export * from "./ReportAgentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports